
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateMeetingTemplateParticipantDtoFormGroup() {
return new FormGroup({
    userId: new FormControl<number | undefined>(undefined),
})
;
}
      